define("checkout/components/payment/tax-id", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isVisible}}
    {{#if (or @hasTaxId this.hasTaxIdError)}}
      <div class="u--m__t__md u--m__b">
        <div class="u--block">
          <label>{{t "checkout.tax.tax_id.title"}}</label>
          {{#if this.hasTaxIdError}}
            <div class="u--flex">
              <p>
                {{svg-jar "warning" class="u--text--light o--icon u--m__r__xs"}}
              </p>
              <p class="u--text--light">
                {{t "checkout.tax.tax_id.validation_error"}}
              </p>
            </div>
          {{else}}
            <p>{{this.businessName}}</p>
            <p>{{this.savedTaxId}}</p>
            {{#if this.hasPendingTaxId}}
              <p class="u--text--light">
                {{svg-jar "warning" class="u--text--light o--icon"}}
                {{t "checkout.tax.tax_id.validation_pending"}}
              </p>
            {{/if}}
          {{/if}}
        </div>
      </div>
    {{else}}
      <div class="u--m__t__md u--m__b">
        {{#if (and @asLinkToggle (not this.isEditing))}}
          {{! Collapsed state is a bare underlined link with no section label }}
          <Shared::Ui::Button
            @class="tCH--text--highlight u--text--underline qa--couponBtn"
            @onClick={{this.toggleIsEditing}}
            @text={{if @collapsedText @collapsedText (t "checkout.tax.show_vat")}}
            @variant="unstyled"
            data-test-id="toggle-editing"
            type="button"
          />
        {{else}}
          <div class="u--block">
            <label>{{t "checkout.tax.tax_id.title"}}</label>
            <Shared::Ui::Button
              @class="{{if this.isEditing 'u--text--light' 'tCH--text--highlight'}}  u--float--right qa--couponBtn"
              @onClick={{this.toggleIsEditing}}
              @text={{if this.isEditing (t "checkout.tax.hide_vat") (t "checkout.tax.show_vat")}}
              @variant="unstyled"
              data-test-id="toggle-editing"
              type="button"
            />
          </div>
        {{/if}}
  
        {{#if this.isEditing}}
          <Shared::TaxIdForm
            @confirmText={{@confirmText}}
            @isDisabled={{not this.canApplyTaxId}}
            @onSubmit={{this.onTaxIdFormSubmit}}
            @taxIdChangeset={{@taxIdChangeset}}
            class="tCH--formWrapper"
          />
        {{/if}}
      </div>
    {{/if}}
  {{/if}}
  */
  {
    "id": "jmBjyjuH",
    "block": "[[[41,[30,0,[\"isVisible\"]],[[[41,[28,[37,1],[[30,1],[30,0,[\"hasTaxIdError\"]]],null],[[[1,\"    \"],[10,0],[14,0,\"u--m__t__md u--m__b\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n        \"],[10,\"label\"],[12],[1,[28,[35,2],[\"checkout.tax.tax_id.title\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"hasTaxIdError\"]],[[[1,\"          \"],[10,0],[14,0,\"u--flex\"],[12],[1,\"\\n            \"],[10,2],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"u--text--light o--icon u--m__r__xs\"]]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"checkout.tax.tax_id.validation_error\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[12],[1,[30,0,[\"businessName\"]]],[13],[1,\"\\n          \"],[10,2],[12],[1,[30,0,[\"savedTaxId\"]]],[13],[1,\"\\n\"],[41,[30,0,[\"hasPendingTaxId\"]],[[[1,\"            \"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n              \"],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"u--text--light o--icon\"]]]],[1,\"\\n              \"],[1,[28,[35,2],[\"checkout.tax.tax_id.validation_pending\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,0],[14,0,\"u--m__t__md u--m__b\"],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,2],[28,[37,5],[[30,0,[\"isEditing\"]]],null]],null],[[[1,\"        \"],[8,[39,6],[[24,\"data-test-id\",\"toggle-editing\"],[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"tCH--text--highlight u--text--underline qa--couponBtn\",[30,0,[\"toggleIsEditing\"]],[52,[30,3],[30,3],[28,[37,2],[\"checkout.tax.show_vat\"],null]],\"unstyled\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"u--block\"],[12],[1,\"\\n          \"],[10,\"label\"],[12],[1,[28,[35,2],[\"checkout.tax.tax_id.title\"],null]],[13],[1,\"\\n          \"],[8,[39,6],[[24,\"data-test-id\",\"toggle-editing\"],[24,4,\"button\"]],[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[29,[[52,[30,0,[\"isEditing\"]],\"u--text--light\",\"tCH--text--highlight\"],\"  u--float--right qa--couponBtn\"]],[30,0,[\"toggleIsEditing\"]],[52,[30,0,[\"isEditing\"]],[28,[37,2],[\"checkout.tax.hide_vat\"],null],[28,[37,2],[\"checkout.tax.show_vat\"],null]],\"unstyled\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,0,[\"isEditing\"]],[[[1,\"        \"],[8,[39,7],[[24,0,\"tCH--formWrapper\"]],[[\"@confirmText\",\"@isDisabled\",\"@onSubmit\",\"@taxIdChangeset\"],[[30,4],[28,[37,5],[[30,0,[\"canApplyTaxId\"]]],null],[30,0,[\"onTaxIdFormSubmit\"]],[30,5]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]]]],[]],null]],[\"@hasTaxId\",\"@asLinkToggle\",\"@collapsedText\",\"@confirmText\",\"@taxIdChangeset\"],false,[\"if\",\"or\",\"t\",\"svg-jar\",\"and\",\"not\",\"shared/ui/button\",\"shared/tax-id-form\"]]",
    "moduleName": "checkout/components/payment/tax-id.hbs",
    "isStrictMode": false
  });
  let TaxIdComponent = _exports.default = (_class = class TaxIdComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "address", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "auth", _descriptor3, this);
      _initializerDefineProperty(this, "stripe", _descriptor4, this);
      _initializerDefineProperty(this, "isEditing", _descriptor5, this);
    }
    get isVisible() {
      return this.address.shouldDisplayTaxAmount && this.address.isSavedAddressValid || this.stripe.isWalletSelected;
    }
    get canApplyTaxId() {
      return this.args.taxIdChangeset.isValid && (0, _utils.isPresent)(this.args.taxIdChangeset.taxId) && (0, _utils.isPresent)(this.args.taxIdChangeset.businessName) && this.args.taxIdChangeset.didConfirm == true;
    }
    get savedTaxId() {
      return this.args.taxIdData?.value ?? this.args.taxIdChangeset.taxId;
    }
    get businessName() {
      return this.args.taxIdData?.businessName ?? this.args.taxIdChangeset.businessName;
    }
    get hasApprovedTaxId() {
      return Boolean(this.args.taxIdData?.status === 'verified');
    }
    get hasPendingTaxId() {
      return Boolean(this.args.taxIdData?.status === 'pending') || Boolean(this.args.taxIdData?.status === 'unavailable');
    }
    get hasTaxIdError() {
      return Boolean(this.args.taxIdData?.status === 'unverified') || this.auth.currentAccount.hasInvalidTaxId;
    }
    toggleIsEditing() {
      this.isEditing = !this.isEditing;
    }
    onTaxIdFormSubmit(event) {
      event.preventDefault();
      // Note: form submit button disabled
      if (!this.canApplyTaxId) {
        return;
      }
      this.segment.track('tax-id-applied-in-checkout');
      this.args.validateTaxId();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isEditing", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleIsEditing", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleIsEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTaxIdFormSubmit", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTaxIdFormSubmit"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TaxIdComponent);
});